/** @module constants */

// board
export const Y_OFFSET = 121;
export const X_OFFSET = 71;
export const WHITE = "White";

// messages
export const PLAY = "PLAY a Card";
export const PLACE = "PLACE a Person";
export const DRAW = "DRAW a Card";
export const RELATIVE = "PLACE a Relative";
export const SACRIFICE = "Choose a SACRIFICE";
export const LAVA_TILE = "Take and Place a Lava Tile";
export const RUN = "RUN FOR YOUR LIVES!!!";

// card types
export const POMP = "Pomp";
export const OMEN = "Omen";
export const AD79 = "AD79";
